<!-- 2 columns form -->
<form name="adform" [formGroup]="adForm" novalidate>
    <div class="panel panel-flat">
        <div class="panel-heading">
            <h5 class="panel-title">Ads</h5>
            <div class="heading-elements">
                <ul class="icons-list">
                    <li>
                        <a data-action="reload" (click)="reset()"></a>
                    </li>
                </ul>
            </div>
            <hr class="divider">
        </div>

        <div class="panel-body">

            <div class="row">
                <div class="col-md-7">


                    <fieldset>
                        <legend class="text-semibold">
                            <i class="icon-list position-left"></i> Ads
                        </legend>
                        <table class="table datatable-column-search-inputs">
                            <thead>
                                <tr>
                                    <th>Client</th>
                                    <th>Title</th>
                                    <th>Subtitle</th>
                                    <th>Status</th>
                                    <th>Remark</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let ad of ads | paginate: { id: 'ads',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                                    <!-- <td>{{ad?.client?.data?.trade_name}}</td> -->
                                    <td>
                                        <div class="media">
                                            <span class="media-left">
                                                <img *ngIf="!ad.client.data.logo" src="assets/img/userm.png" width="40"
                                                    height="40" class="img-circle img-md" alt="">
                                                <a href="javascript:void(0)" data-toggle="modal" data-target="#adModal"
                                                    (click)="editAd(ad)">
                                                    <img *ngIf="ad.client.data.logo"
                                                        [src]="baseUrl+'assets/'+ad.client.data.logo+'/render'"
                                                        width="40" height="40" class="img-circle img-md" alt="">
                                                </a>
                                            </span>
                                            <div class="media-right">{{ad?.client?.data?.trade_name}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ad?.title}}</td>
                                    <td>{{ad?.subtitle}}</td>
                                    <td>
                                        <span class="label label-block label-default"
                                            *ngIf="ad.status === 'Pending' || ad.status === 'pending'">{{ad.status}}</span>
                                        <span class="label label-block bg-primary"
                                            *ngIf="ad.status === 'Active' || ad.status === 'active'">{{ad.status}}</span>
                                        <span class="label label-block bg-danger"
                                            *ngIf="ad.status === 'Expired' || ad.status === 'expired'">{{ad.status}}</span>
                                    </td>
                                    <td>{{ad.remark}}</td>
                                    <td class="text-center">
                                        <ul class="icons-list">
                                            <li class="dropdown">
                                                <a href="" class="dropdown-toggle" data-toggle="dropdown">
                                                    <i class="icon-menu9"></i>
                                                </a>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                        <!--  <a href="" [routerLink]="['/adadd']" [queryParams]="{'id':ad.id}"> -->
                                                        <a href="javascript:void(0);" (click)="editAd(ad)">
                                                            <i class="icon-file-pdf"></i>Update</a>
                                                    </li>
                                                    <li>
                                                        <a href="">
                                                            <i class="icon-file-excel"></i>Delete</a>
                                                    </li>
                                                    <li class="dropdown-submenu dropdown-submenu-left">
                                                        <a href="javascript:void(0);">Change Status</a>
                                                        <ul class="dropdown-menu">
                                                            <li>
                                                                <a (click)="changeStatus(ad.id,'pending')">
                                                                    <i class="icon-shuffle"></i> Pending</a>
                                                            </li>
                                                            <li>
                                                                <a (click)="changeStatus(ad.id,'active')">
                                                                    <i class="icon-shuffle"></i> Active</a>
                                                            </li>
                                                            <li>
                                                                <a (click)="changeStatus(ad.id,'expired')">
                                                                    <i class="icon-shuffle"></i> Expired</a>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr *ngIf="ads?.length <=0">
                                    <td colspan="6" class="text-center"> <i class="icon-info22">&nbsp;</i>No Ads placed
                                        yet!</td>
                                </tr>
                            </tbody>
                        </table>


                        <div class="row">
                            <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
                            <div class="text-center">

                                <pagination-controls id="ads" (pageChange)="pageChanged(currentPage = $event)">
                                </pagination-controls>

                                <br>
                            </div>

                        </div>

                    </fieldset>
                </div>


                <div class="col-md-5">

                    <fieldset>
                        <legend class="text-semibold">
                            <i class="icon-reading position-left"></i> Ad Details
                        </legend>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group required">
                                    <span class="control-label"> Client: </span>
                                    <ng-select [items]="clients" placeholder="" formControlName="client" bindValue="id"
                                        bindLabel="trade_name" required>
                                    </ng-select>
                                    <div class="help-block" *ngIf="client.invalid && (client.dirty || client.touched)">
                                        <p class="text-danger">
                                            <i class="icon-cancel-circle2 position-left text-red"></i> Client is
                                            required
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group required">
                                    <span class="control-label">Status: </span>
                                    <select name="status" required formControlName="status" class="form-control"
                                        data-placeholder="Select offer status">
                                        <option selected disabled>Status:</option>
                                        <option value="pending">Pending</option>
                                        <option value="active">Active</option>
                                        <option value="expired">Expired</option>
                                    </select>
                                    <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                                        <p class="text-danger">
                                            <i class="icon-cancel-circle2 position-left"></i>Offer status is required.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group required">
                                    <span class="control-label"> Title: </span>
                                    <input type="text" name="title" required formControlName="title"
                                        class="form-control" placeholder="Title">
                                    <div class="help-block" *ngIf="title.invalid && (title.dirty || title.touched)">
                                        <p class="text-danger">
                                            <i class="icon-cancel-circle2 position-left text-red"></i> Title is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group required">
                                    <span class="control-label">Subtitle: </span>
                                    <input type="text" name="registration_date" formControlName="subtitle"
                                        class="form-control" placeholder="Subtitle">
                                    <!-- <div class="help-block"
                      *ngIf="transaction_date.invalid && (transaction_date.dirty || transaction_date.touched)">
                      <p class="text-danger">
                        <i class="icon-cancel-circle2 position-left"></i>Transaction date is required.
                      </p>
                    </div> -->
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group">
                                <label>&nbsp;</label>
                                <label>Remark:</label>
                                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                                    placeholder="Additional information . . ." required></textarea>
                                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                                    <p class="text-danger">
                                        <i class="icon-cancel-circle2 position-left"></i>Please write small description
                                        about the ad
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!--  <ngx-dropzone (change)="onSelect($event)">
                                <ngx-dropzone-label> - Drop Ad Banner here - </ngx-dropzone-label>
                                <ngx-dropzone-preview *ngFor="let f of files" [removable]="true"
                                    (removed)="onRemove(f)">
                                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                            </ngx-dropzone> -->
                            <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'"
                                (change)="onFilesAdded($event)">
                                <ngx-dropzone-label>
                                    <div>
                                        <h6 style="color:gray;" translate>- Drop Ad Banner here -</h6>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                </ngx-dropzone-image-preview>
                            </div>

                        </div><br>

                    </fieldset>

                    <div class="text-right">

                        <!--  <button class="btn bg-slate-800" (click)="addNews(ad.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
                <span *ngIf="!ad.id">Save News</span>
                <span *ngIf="ad.id">Update News</span>
                <i class="icon-floppy-disk position-right"></i>
              </button> -->
                        <button class="btn bg-slate-800" (click)="addAd(ad?.id)" type="submit" data-style="slide-right"
                            [disabled]="adForm.invalid">
                            <span *ngIf="ad?.id">Update</span><span *ngIf="!ad?.id">Add</span> Ad
                                <i class="icon-floppy-disk position-right"></i>
                        </button>

                    </div>


                </div>

            </div>





        </div>
    </div>
</form>
<!-- /2 columns form -->

<!-- Ad modal -->
<div id="adModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h5 class="modal-title">Ad</h5>
            </div>
            <hr>
            <div class="modal-body">
                <div>
                    <div class="">
                        <h6>Logo</h6>
                        <hr>
                        <div class="">
                            <div class="thumb thumb-rounded text-center">
                                <img *ngIf="!ad?.client?.data?.logo" src="assets/img/userm.png" width="100" height="100"
                                    class="img-circle img-md" alt="">
                                <img *ngIf="ad?.client?.data?.logo" width="50" height="50"
                                    [src]="baseUrl+'assets/'+ad?.client?.data?.logo+'/render'" alt="Profile Imag"
                                    class="profileImg img-responsive">
                            </div>
                        </div>
                    </div>
                    <h6>Banner</h6>
                    <hr>
                    <div class="well" style="min-height: 250px;">
                        <img [src]="baseUrl+'assets/'+ad?.banner+'/render'" alt="ID Front"
                            class="profileImg img-responsive">
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</div>
<!-- /Ad modal -->